"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mui = require("tss-react/mui");
var _material = require("@mui/material");
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _StyledToggle = _interopRequireDefault(require("../StyledToggle"));
var _excluded = ["title", "description", "checked", "onChange", "dividerPosition", "titleClassName"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    title: {
      fontWeight: 600,
      color: theme.palette.darkGrey.main
    },
    description: {
      color: theme.palette.darkGrey.light
    },
    switchContainer: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    divider: {
      margin: theme.spacing(2, 0)
    }
  };
});
var SingleSwitch = function SingleSwitch(_ref) {
  var title = _ref.title,
    description = _ref.description,
    checked = _ref.checked,
    onChange = _ref.onChange,
    dividerPosition = _ref.dividerPosition,
    titleClassName = _ref.titleClassName,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, dividerPosition === 'top' && /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    variant: "middle",
    className: classes.divider,
    "data-testid": "divider-top"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.switchContainer
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: cx(titleClassName, classes.title)
  }, title), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: classes.description
  }, description)), /*#__PURE__*/_react["default"].createElement(_StyledToggle["default"], _extends({
    checked: checked,
    onChange: onChange
  }, other))), dividerPosition === 'bottom' && /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    variant: "middle",
    className: classes.divider,
    "data-testid": "divider-bottom"
  }));
};
SingleSwitch.propTypes = {
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string.isRequired,
  checked: _propTypes["default"].bool.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  dividerPosition: _propTypes["default"].oneOf(['top', 'bottom']),
  titleClassName: _propTypes["default"].string
};
SingleSwitch.defaultProps = {
  dividerPosition: undefined,
  titleClassName: undefined
};
var _default = SingleSwitch;
exports["default"] = _default;